<template>
  <div class="ResetPassword full-height">
    <ld-header
      :left-options="{ backText: '返回' }"
      @click-left="back"
    >
      密码重置 {{ step }}/3
    </ld-header>

    <div class="resetPassword-cnt">
      <div class="welcome font48 font-lg">
        {{ tips[step - 1] }}
      </div>

      <router-view />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ldHeader from 'Common/ldHeader'
import { sessionclear } from 'Utils/storage'

export default {
  components: {
    ldHeader
  },
  created() {
    this.$store.registerModule('ResetPassword', {
      namespaced: true,
      state: {
        step: 1,
        telphone: '',
        validCode: ''
      },
      mutations: {
        SET_STEP: (state, states) => {
          state.step = states
        },
        SET_TELPHONE: (state, states) => {
          state.telphone = states
        },
        SET_VALIDCODE: (state, states) => {
          state.validCode = states
        }
      }
    })
  },
  data () {
    return {
      tips: ['输入手机号码', '输入验证码', '请设置密码']
    } 
  },
  methods: {
    back () {
      this.$dialog.confirm({
        message: '确认放弃重置密码吗？',
        cancelButtonText: '继续重置'
      }).then(()=>{
        sessionclear()
        window.location.href = '#/login'
      })
    },
    test () {
      console.log(this)
      console.log(this.$store)
    }
  },
  computed: {
    ...mapState('ResetPassword', {
      step: state => state.step
    })
  },
  destroyed () {
    this.$store.unregisterModule('ResetPassword')
  }
}
</script>

<style lang="less">
.ResetPassword {
  color: @color-text-black;
  background-color: @color-text-white;
  
  .resetPassword-cnt {
    padding: 0 .6rem;

    .welcome {
      padding: .5rem 0 .8rem;
    }

    .submit-btn {
      margin-top: 2.84rem;
    }
  
  }
}

</style>
